import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

type PageState = {
  navigateTo: string | null;
};

type UseRedirectParams = {
  pageState: PageState;
  clearNavigateTo: () => { type: string };
};

const useRedirect = ({ pageState, clearNavigateTo }: UseRedirectParams) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (pageState.navigateTo) {
      navigate(pageState.navigateTo);
      (dispatch as (a: unknown) => unknown)(clearNavigateTo());
    }
  }, [pageState.navigateTo, navigate, dispatch, clearNavigateTo]);
};

export default useRedirect;
